import apiBase from "../../api/axios";
import Cookies from "js-cookie";

export const loginService = async (credentials) => {
  const response = await apiBase.post("v1/token/", credentials);
//   console.log(response);
  const { access, refresh } = response.data.data;
//   console.log(access);
  //Access
  Cookies.set("access_token", access, {
    expires: 1,
    secure: true,
    sameSite: "strict",
  });

  //REFRESH
  Cookies.set("refresh_token", refresh, {
    expires: 7,
    secure: true,
    sameSite: "strict",
  });

  return { access, refresh };
};

export const logoutService = () => {
  Cookies.remove("access_token");
  Cookies.remove("refresh_token");
};
